// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3lvnM","row":"Node_row__3gEbf","label":"Node_label__2aJ3K","footer":"Node_footer__2wCwN"};